import { useState, useEffect } from "react";
import getClassName from "../../utilities/getClassName";

const NumberInput = ({
    id,
    icon,
    defaultValue = 1,
    value,
    min = 1,
    max = 99,
    validateForm,
    onFocus,
    skeleton,
    classNames = [],
}) => {
    const [currentValue, setCurrentValue] = useState(defaultValue);
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        if (defaultValue !== undefined && defaultValue !== null) {
            setCurrentValue(defaultValue);
        }
    }, [defaultValue]);

    useEffect(() => {
        if (validateForm) {
            setHasError(!currentValue || currentValue < min);
        }
    }, [validateForm, currentValue, min]);

    const handleIncrement = () => {
        if (currentValue < max) {
            const newValue = currentValue + 1;
            setCurrentValue(newValue);
            if (value) value(newValue);
            if (onFocus) onFocus();
        }
    };

    const handleDecrement = () => {
        if (currentValue > min) {
            const newValue = currentValue - 1;
            setCurrentValue(newValue);
            if (value) value(newValue);
            if (onFocus) onFocus();
        }
    };

    const handleChange = (e) => {
        const inputValue = e.target.value;

        // Allow empty input temporarily while typing
        if (inputValue === "") {
            setCurrentValue("");
            return;
        }

        const newValue = parseInt(inputValue);

        if (!isNaN(newValue)) {
            // Allow setting the value even if outside range, will be clamped on blur
            setCurrentValue(newValue);

            // Only call value callback if within valid range
            if (newValue >= min && newValue <= max) {
                if (value) value(newValue);
                if (onFocus) onFocus();
            }
        }
    };

    const handleBlur = () => {
        // Clamp value to min/max on blur
        if (currentValue === "" || currentValue < min) {
            setCurrentValue(min);
            if (value) value(min);
        } else if (currentValue > max) {
            setCurrentValue(max);
            if (value) value(max);
        }
    };

    const classes = getClassName([
        "number-input",
        hasError ? "number-input--error" : "",
        skeleton ? "number-input--skeleton" : "",
        ...classNames,
    ]);

    return (
        <fieldset className={classes}>
            <div className="number-input__container">
                {icon && <img src={icon} alt="" className="number-input__icon" />}
                <button
                    type="button"
                    className="number-input__button number-input__button--minus"
                    onClick={handleDecrement}
                    disabled={currentValue <= min}
                >
                    −
                </button>
                <input
                    id={id}
                    type="number"
                    className="number-input__field"
                    value={currentValue}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    min={min}
                    max={max}
                />
                <button
                    type="button"
                    className="number-input__button number-input__button--plus"
                    onClick={handleIncrement}
                    disabled={currentValue >= max}
                >
                    +
                </button>
            </div>
        </fieldset>
    );
};

export default NumberInput;
